module.exports = __webpack_public_path__ + "img/antes_despues_142.4faccddf.png";